export default {
  data() {
    return {
      validacaoId: "servicos",
      errorsServicos: {
        campoOutrosServicos: ""
      },
      mensagemDeErroServicos: {
        servicos: ""
      }
    };
  },
  methods: {
    chequeOutrosServicos(novoValor) {
      if (!this.servicos) return;

      if (this.servicos.length < 1) {
        this.mensagemDeErroServicos.servicos = "Selecione ao menos 1 serviço";
      } else {
        this.mensagemDeErroServicos.servicos = "";
      }

      if (novoValor.length > 0 && !this.campoOutros) {
        this.errorsServicos.campoOutrosServicos = "Este campo é Obrigatório!";
      } else {
        this.errorsServicos.campoOutrosServicos = "";
      }
    },
    checkoutCompletoErrors() {
      let temErro = false;
      Object.values(this.errorsServicos).forEach(err => {
        if (err.length > 0) {
          temErro = true;
        }
      });
      Object.values(this.mensagemDeErroServicos).forEach(err => {
        if (err.length > 0) {
          temErro = true;
        }
      });
      return temErro;
    }
  },
  computed: {
    temErrors() {
      let temErro = false;
      Object.values(this.errorsServicos).forEach(err => {
        if (err.length > 0) {
          temErro = true;
        }
      });
      Object.values(this.mensagemDeErroServicos).forEach(err => {
        if (err.length > 0) {
          temErro = true;
        }
      });
      return temErro;
    }
  },
  watch: {
    servicos: "chequeOutrosServicos",
    temErrors(boo) {
      const payload = {
        temErro: boo,
        validacaoId: this.validacaoId
      };
      this.$emit("error", payload);
    },
    campoOutros: function(novoValor) {
      if (!novoValor) return;

      if (
        novoValor.length > 0 ||
        (novoValor.length == 0 && this.servicos.length == 0)
      ) {
        this.errorsServicos.campoOutrosServicos = "";
      } else {
        this.errorsServicos.campoOutrosServicos = "Este campo é Obrigatório!";
      }
    }
  }
};
